var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31322 5.44448C6.87307 5.6972 5.71902 6.21323 6.42191 6.85897C6.76527 7.17441 7.14768 7.4 7.62847 7.4H10.3719C10.8527 7.4 11.2351 7.17441 11.5785 6.85897C12.2814 6.21323 11.1273 5.6972 10.6872 5.44448C9.65503 4.85184 8.34536 4.85184 7.31322 5.44448Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1998 2.2C10.1998 2.86274 9.66255 3.4 8.9998 3.4C8.33706 3.4 7.7998 2.86274 7.7998 2.2C7.7998 1.53726 8.33706 1 8.9998 1C9.66255 1 10.1998 1.53726 10.1998 2.2Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5134 15.0441C12.0733 15.2968 10.9192 15.8128 11.6221 16.4586C11.9655 16.774 12.3479 16.9996 12.8287 16.9996H15.5721C16.0529 16.9996 16.4353 16.774 16.7787 16.4586C17.4816 15.8128 16.3275 15.2968 15.8874 15.0441C14.8552 14.4515 13.5456 14.4515 12.5134 15.0441Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 11.7996C15.4 12.4624 14.8627 12.9996 14.2 12.9996C13.5373 12.9996 13 12.4624 13 11.7996C13 11.1369 13.5373 10.5996 14.2 10.5996C14.8627 10.5996 15.4 11.1369 15.4 11.7996Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11302 15.0441C1.67287 15.2968 0.518824 15.8128 1.22172 16.4586C1.56507 16.774 1.94749 16.9996 2.42827 16.9996H5.17173C5.65251 16.9996 6.03493 16.774 6.37828 16.4586C7.08118 15.8128 5.92713 15.2968 5.48698 15.0441C4.45483 14.4515 3.14517 14.4515 2.11302 15.0441Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99961 11.7996C4.99961 12.4624 4.46235 12.9996 3.79961 12.9996C3.13687 12.9996 2.59961 12.4624 2.59961 11.7996C2.59961 11.1369 3.13687 10.5996 3.79961 10.5996C4.46235 10.5996 4.99961 11.1369 4.99961 11.7996Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.7998V11.7998M9 11.7998L11 12.9998M9 11.7998L7 12.9998",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.0b9a289534d7cbef93eb0bc58008a896.svg";
export { ForwardRef as ReactComponent };